import dayjs from "dayjs";

/**
 * 计算时间间隔推荐值
 * @param {string|number|Date} startTimeStr - 起始时间，可以是时间戳、字符串或Date对象
 * @param {string|number|Date} endTimeStr - 结束时间，可以是时间戳、字符串或Date对象
 * @returns {{intervalValue: number, intervalUnit: string}} 推荐的时间间隔
 */
export default function getTimeInterval(startTimeStr, endTimeStr) {
	let start = "";
	let end = "";

	if (endTimeStr === "now") {
		end = dayjs();
	} else if (endTimeStr) {
		end = dayjs(endTimeStr).valueOf();
	}

	if (
		startTimeStr &&
		typeof startTimeStr === "string" &&
		startTimeStr.startsWith("now-")
	) {
		const match = startTimeStr.match(/^now-(\d+)([mhd])$/);
		if (match) {
			const value = parseInt(match[1], 10);
			const unit = match[2];
			let ms = 0;
			if (unit === "m") ms = value * 60 * 1000;
			if (unit === "h") ms = value * 60 * 60 * 1000;
			if (unit === "d") ms = value * 24 * 60 * 60 * 1000;
			start = Date.now() - ms;
		}
	} else if (startTimeStr) {
		start = dayjs(startTimeStr).valueOf();
	}

	if (!start || !end) {
		return { intervalValue: 1, intervalUnit: "h" };
	}

	// dayjs对象时用diff，否则用数值
	const diffInMinutes = (end.diff ? end.diff(start, "minute") : (end - start) / 60000);
	if (diffInMinutes <= 5) {
		return { intervalValue: 1, intervalUnit: "min" };
	} else if (diffInMinutes <= 15) {
		return { intervalValue: 5, intervalUnit: "min" };
	} else if (diffInMinutes <= 30) {
		return { intervalValue: 10, intervalUnit: "min" };
	} else if (diffInMinutes <= 60) {
		return { intervalValue: 5, intervalUnit: "min" };
	} else if (diffInMinutes <= 6 * 60) {
		return { intervalValue: 30, intervalUnit: "min" };
	} else if (diffInMinutes <= 24 * 60) {
		return { intervalValue: 1, intervalUnit: "h" };
	} else if (diffInMinutes <= 7 * 24 * 60) {
		return { intervalValue: 6, intervalUnit: "h" };
	} else if (diffInMinutes <= 30 * 24 * 60) {
		return { intervalValue: 1, intervalUnit: "d" };
	} else if (diffInMinutes <= 90 * 24 * 60) {
		return { intervalValue: 1, intervalUnit: "w" };
	} else {
		return { intervalValue: 1, intervalUnit: "mo" };
	}
}
